export default __webpack_public_path__ + "static/media/banner.e8ad7a53.png";